import { USER_MENU_ITEMS } from "@/constants";
import React, { memo } from "react";

const UserMenuList = memo(({ open, compact = false }: { open: boolean; compact?: boolean }) => (
  <div className="py-1">
    {USER_MENU_ITEMS.map(({ icon, label, danger }, i) => (
      <React.Fragment key={label}>
        {danger && (
          <div className={`my-1 border-t border-white/10 ${compact ? 'mx-2.5' : 'mx-3'}`} />
        )}
        <button
          type="button"
          className={`
            w-full flex items-center text-left cursor-pointer
            ${compact ? 'gap-2.5 px-3.5 py-2.5 text-[13px]' : 'gap-3 px-4 py-2.5 text-[13px]'}
            ${danger
              ? 'text-red-400 hover:bg-red-500/10 font-semibold'
              : 'text-slate-300 hover:bg-white/5 hover:text-white'}
          `}
          style={{
            opacity: open ? 1 : 0,
            transform: open ? 'translateX(0)' : `translateX(${compact ? '-8px' : '-10px'})`,
            transitionDelay: open ? `${(i + 1) * (compact ? 40 : 45)}ms` : '0ms',
            transitionProperty: 'opacity, transform',
            transitionDuration: '220ms',
            transitionTimingFunction: 'cubic-bezier(0.34,1.56,0.64,1)',
          }}
        >
          <span className={danger ? 'text-red-400' : 'text-slate-400'}>{icon}</span>
          {label}
        </button>
      </React.Fragment>
    ))}
  </div>
));

export default UserMenuList;